import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { TenantsFacade } from '@core/sso/facades/tenants.facade';
import { TopNavigationPath } from '@core/navigation/models/top-navigation/top-navigation-path';

export const hasTenantsGuard: CanMatchFn = () => {
  const tenantsFacade = inject(TenantsFacade);
  const router = inject(Router);

  return tenantsFacade.tenants$.pipe(
    map(tenants => {
      if (tenants) {
        return true;
      }

      return router.createUrlTree([TopNavigationPath.Home]);
    })
  );
};
